import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useClientUIContext } from './context/ClientByIdUIContext';
import { usersService } from '../../../services';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { LocationSVG } from '../../../components';
import AddressSection from './forms/sections/AddressSection';
import { useTranslation } from 'react-i18next';
// import { getCountryId, getProvinceId } from '../../../helpers/matchStates';
import { getColor } from '../../../helpers/getColor';
import CustomAlert from '../../../components/Alert';

export default function ClientAddressById () {
    const { t } = useTranslation();
    // Get client Id from url params
    const { id } = useParams();
    const clientId = parseInt(id);

    // eslint-disable-next-line no-unused-vars
    const [realAddress, setRealAddress] = React.useState();
    const [address, setAddress] = React.useState();

    // Alert states

    const [openAlert, setOpenAlert] = useState(false);
    const [alert, setAlert] = useState({
        severity: '',
        title: '',
        description: '',
        className: ''
    });

    const clientUIContext = useClientUIContext();
    const clientUIProps = useMemo(() => {
        return {
            isLoading: clientUIContext.isLoading,
            setIsLoading: clientUIContext.setIsLoading,
            queryParams: clientUIContext.queryParams,
            setQueryParams: clientUIContext.setQueryParams
        };
    }, [clientUIContext]);

    const getAddress = () => {
        clientUIProps.setIsLoading(true);

        usersService
            .getById(clientId)
            .then(async client => {
                // Parse the birth date because JS extracts one day
                if (client.person?.attributes?.address) {
                    setAddress(JSON.parse(client.person.attributes.address.value));
                }
                if (client.person?.attributes?.address_real) {
                    setRealAddress(JSON.parse(client.person.attributes.address_real.value));
                }
                clientUIProps.setIsLoading(false);

                return false;
            })
            .catch(e => {
                setAlert({
                    isOpen: true,
                    severity: 'error',
                    title: t('errors.generalTitle'),
                    description: t('errors.generalDescription'),
                    className: 'clientsMC_Alert--error'
                });
                console.error(e);
                clientUIProps.setIsLoading(false);
            });
    };

    // const handleSumbmitRealAddress = (address) => {
    //     address.id_state = getProvinceId(address.state);
    //     address.id_country = getCountryId(address.country);

    //     clientUIProps.setIsLoading(true);

    //     const body = {
    //         person: {
    //             attributes: [{
    //                 description: 'address_real',
    //                 value: JSON.stringify(address)
    //             }]
    //         }
    //     };
    //     usersService.editById(clientId, body)
    //         .catch(e => {
    //             setAlert({
    //                 isOpen: true,
    //                 severity: 'error',
    //                 title: t('errors.generalTitle'),
    //                 description: t('errors.generalDescription'),
    //                 className: 'clientsMC_Alert--error'
    //             });
    //             console.error(e);
    //         })
    //         .finally(() => {
    //             getAddress();
    //         });
    // };

    React.useEffect(() => {
        getAddress();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <CustomAlert
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                alert={alert}
                setAlert={setAlert}
            />
            <Box style={{ backgroundColor: '#FFF', boxShadow: '0px 0px 30px 0px rgba(82, 63, 105, 0.06)' }} width={'100%'} marginTop={'1rem'} padding={'1rem'} >

                <Box
                    gap={'1rem'}>
                    <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'>
                        <Box display='flex' gap={'8px'}>
                            {<LocationSVG customStroke={getColor('primary', 700)} />}
                            <Typography variant='h5'>{t('details.subDescriptions.address')}</Typography>
                        </Box>
                    </Box>
                    {
                        clientUIProps.isLoading ? <Stack alignItems={'center'}><CircularProgress size={24} style={{ color: 'primary' }} /></Stack>
                            : <Box>
                                <AddressSection address={address}/>
                                {/* {realAddress
                                    ? <AddressSection address={realAddress} title={t('details.realAddressInputs.address')}/>
                                    : <RealAddressForm handleOnSubmit={handleSumbmitRealAddress}/>} */}
                            </Box>
                    }
                </Box>
            </Box></>

    );
}
